import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.presentation');
import { OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;

@Component({
    selector: 'wiz-layout-presentation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.presentation/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.progress-bar {
  transition: width 0.3s ease;
}`],
})
export class LayoutPresentationComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public currentSlide: number = 1;
    public totalSlides: number = 19;
    private routerSub: any;

    // Go-to popover
    public showGoto: boolean = false;
    public gotoInput: number = 1;

    // Fullscreen
    public isFullscreen: boolean = false;

    // Touch swipe
    private touchStartX: number = 0;
    private touchStartY: number = 0;

    // Overview panel
    public showOverview: boolean = false;
    public slideTitles: string[] = [
        '제목',
        'COMPAS란 무엇인가',
        '위험도 점수 스케일',
        'ProPublica의 비판',
        'ProPublica가 본 것',
        'Northpointe의 반박',
        '왜 결론이 다른가?',
        '공정성 지표 비교',
        '임계값 시뮬레이션',
        '불가능성 정리',
        'COMPAS vs 인간 판단',
        'COMPAS vs 인간 — 시사점',
        'Blackstone vs Cheney 원칙',
        'Blackstone vs Cheney 시각화',
        '인간도 편향적이다 (1)',
        '인간도 편향적이다 (2)',
        '투명성·감사·책임',
        '알고리즘 책임성 프레임워크',
        'Q&A / 참고 문헌'
    ];

    // Help overlay
    public showHelp: boolean = false;

    @ViewChild('gotoInputEl') gotoInputEl!: ElementRef;

    public async ngOnInit() {
        await this.service.init();
        this.parseSlide();
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                this.parseSlide();
                await this.service.render();
            }
        });

        if (this.service.event) {
            this.service.event.on('slidesLoaded', (total: number) => {
                this.totalSlides = total;
                this.service.render();
            });
        }
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private parseSlide() {
        const num = parseInt(WizRoute.segment.num || '1');
        this.currentSlide = (num >= 1 && num <= this.totalSlides) ? num : 1;
    }

    @HostListener('document:keydown', ['$event'])
    public handleKeydown(event: KeyboardEvent) {
        // Ignore when typing in input
        if (event.target instanceof HTMLInputElement) return;

        if (event.key === 'Escape') {
            if (this.showGoto) { this.showGoto = false; this.service.render(); return; }
            if (this.showOverview) { this.showOverview = false; this.service.render(); return; }
            if (this.showHelp) { this.showHelp = false; this.service.render(); return; }
            return;
        }
        if (event.key === 'ArrowRight' || event.key === ' ') {
            event.preventDefault();
            this.nextSlide();
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.prevSlide();
        } else if (event.key === 'f' || event.key === 'F') {
            this.toggleFullscreen();
        } else if (event.key === 'o' || event.key === 'O') {
            this.toggleOverview();
        } else if (event.key === 'g' || event.key === 'G') {
            this.openGoto();
        } else if (event.key === '?') {
            this.showHelp = !this.showHelp;
            this.service.render();
        }
    }

    @HostListener('document:fullscreenchange')
    public onFullscreenChange() {
        this.isFullscreen = !!document.fullscreenElement;
        this.service.render();
    }

    // Touch swipe
    @HostListener('document:touchstart', ['$event'])
    public onTouchStart(event: TouchEvent) {
        this.touchStartX = event.changedTouches[0].screenX;
        this.touchStartY = event.changedTouches[0].screenY;
    }

    @HostListener('document:touchend', ['$event'])
    public onTouchEnd(event: TouchEvent) {
        const deltaX = event.changedTouches[0].screenX - this.touchStartX;
        const deltaY = event.changedTouches[0].screenY - this.touchStartY;
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
            if (deltaX < 0) this.nextSlide();
            else this.prevSlide();
        }
    }

    public nextSlide() {
        if (this.currentSlide < this.totalSlides) {
            this.service.href(`/slide/${this.currentSlide + 1}`);
        }
    }

    public prevSlide() {
        if (this.currentSlide > 1) {
            this.service.href(`/slide/${this.currentSlide - 1}`);
        }
    }

    // Go-to popover
    public async openGoto() {
        this.gotoInput = this.currentSlide;
        this.showGoto = true;
        this.showHelp = false;
        this.showOverview = false;
        await this.service.render();
        setTimeout(() => {
            if (this.gotoInputEl) this.gotoInputEl.nativeElement.focus();
        }, 50);
    }

    public gotoSlide() {
        const num = this.gotoInput;
        if (num >= 1 && num <= this.totalSlides) {
            this.showGoto = false;
            this.service.href(`/slide/${num}`);
        }
    }

    public onGotoKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') this.gotoSlide();
        if (event.key === 'Escape') { this.showGoto = false; this.service.render(); }
    }

    // Fullscreen
    public toggleFullscreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    }

    // Overview panel
    public toggleOverview() {
        this.showOverview = !this.showOverview;
        this.showHelp = false;
        this.showGoto = false;
        this.service.render();
    }

    public gotoFromOverview(num: number) {
        this.showOverview = false;
        this.service.href(`/slide/${num}`);
    }
}

export default LayoutPresentationComponent;